/*eslint-disable */
import { RootState } from '@/store/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Api } from "@/api/api";
import { Smartwatch } from "@/domain/smartwatch";

export interface SmartwatchState {
    smartwatches: Smartwatch[];
    smartwatchesReadyToConnect: Smartwatch[];
    smartwatchToConnect: Smartwatch | undefined;
    smartwatchToEdit: Smartwatch | undefined;
}

export const state: SmartwatchState = {
    smartwatches: [],
    smartwatchesReadyToConnect: [],
    smartwatchToConnect: undefined,
    smartwatchToEdit: undefined
};

export const getters: GetterTree<SmartwatchState, RootState> = {
    getAllSmartwatches: state => state.smartwatches,
    getAvailableSmartwatches: state => state.smartwatchesReadyToConnect,
    getSmartwatchToConnect: state => state.smartwatchToConnect,
    getSmartwatchToEdit: state => state.smartwatchToEdit
};

export const mutations: MutationTree<SmartwatchState> = {
    SET_ALL_SMARTWATCHES: (state, smartwatches) => {
        state.smartwatches = smartwatches
    },
    SET_AVAILABLE_SMARTWATCHES: (state, smartwatches) => {
        state.smartwatchesReadyToConnect = smartwatches;
    },
    SET_SMARTWATCH_TO_CONNECT: (state, smartwatchId) => {
        state.smartwatchToConnect = state.smartwatchesReadyToConnect.find(smartwatch => smartwatch.id === smartwatchId);

    },
    SET_SMARTWATCH_TO_EDIT: (state, smartwatch) => state.smartwatchToEdit = smartwatch
};

export const actions: ActionTree<SmartwatchState, RootState> = {
    FETCH_ALL_SMARTWATCHES({ commit }) {
        return Api.Smartwatch.fetchAllSmartwatches()
            .then(response => commit('SET_ALL_SMARTWATCHES', response.smartwatches))
    },
    FETCH_ALL_AVAILABLE_SMARTWATCHES({ commit }) {
        return Api.Smartwatch.fetchAllAvailableSmartwatches()
            .then(response => commit('SET_AVAILABLE_SMARTWATCHES', response.smartwatches))
    },
    async SAVE_NEW_SMARTWATCH({ commit }, newSmartwatch: Smartwatch) {
        return await Api.Smartwatch.saveNewSmartwatch(newSmartwatch);
    },
    async UPDATE_SMARTWATCH({ commit }, updatedSmartwatch: Smartwatch) {
        return await Api.Smartwatch.updateSmartwatch(updatedSmartwatch);
    },
    async DELETE_SMARTWATCH({ commit }, smartwatchId : number) {
        return await Api.Smartwatch.deleteSmartwatch(smartwatchId);
    }
};

export const SmartwatchStore: Module<SmartwatchState, RootState> = {
    state,
    getters,
    mutations,
    actions
};
